import './App.css';
import React, { useEffect } from 'react';
import { createBrowserRouter, RouterProvider, Outlet, ScrollRestoration as RouterScrollRestoration, useLocation } from 'react-router-dom';
import Main from './Main';
import Lenis from 'lenis';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Card from './Components/DCard';
import SearchPage from './Components/SearchPage';
import NotFound from './Components/NotFound';
import Form from './Components/Form';
import Reviews from './Components/Reviews';
import WriteReviews from './Components/WriteReviews';
import Itinerary from './Components/Itinerary';
import Admin from './Admin';
import AdminPanel from './AdminPanel';
import ProtectedRoute from './ProtectedRoute';
import AddPackage from './AddPackage';
import EditPackage from './EditPackage';
import 'antd/dist/reset.css';

gsap.registerPlugin(ScrollTrigger);

const RootLayout = () => {
  const location = useLocation();
  const isAdminRoute = (
    location.pathname.startsWith('/admin') ||
    // location.pathname === (process.env.REACT_APP_CLIENT_SITE || '/admin-panel') ||
    // location.pathname === (process.env.REACT_APP_EDIT_PACKAGES || '/admin/edit-package') ||
    // location.pathname.startsWith(process.env.REACT_APP_ADDING_INSTANCE || '/admin/add-package') ||
    (location.pathname.startsWith('/packages/') && location.pathname.endsWith('-itinerary'))
  );

  const isReviewRoute = location.pathname.startsWith('/reviews');
  const isForm = location.pathname === '/Form';

  
  useEffect(() => {
    if (isAdminRoute || isReviewRoute || isForm) {
      return;
    }

    const lenis = new Lenis({
      smooth: true,
      lerp: 0.1,
    });
    window.lenis = lenis;

    lenis.on('scroll', ScrollTrigger.update);

    gsap.ticker.add((time) => {
      lenis.raf(time * 1000);
    });

    gsap.ticker.lagSmoothing(0);

    const handleRouteChangeStart = () => {
      lenis.stop();
    };

    const handleRouteChangeComplete = () => {
      lenis.start();
    };

    const unlisten = router.subscribe((state) => {
      if (!state.location.pathname.startsWith(process.env.REACT_APP_CLIENT_ACCESS || "/admin") &&
          state.location.pathname !== (process.env.REACT_APP_CLIENT_SITE || "/admin-panel") &&
          state.location.pathname !== (process.env.REACT_APP_ADDING_INSTANCE || "/admin/add-package")
        ) {
        handleRouteChangeStart();
        setTimeout(handleRouteChangeComplete, 100);
      }
    });

    return () => {
      lenis.destroy();
      gsap.ticker.remove(lenis.raf);
      unlisten();
    };
  }, [isAdminRoute, isReviewRoute, isForm]);

  
  useEffect(() => {
    if (window.lenis && !isAdminRoute && !isReviewRoute && !isForm) {
      setTimeout(() => {
        window.lenis.resize();
      }, 100);
    }
  }, [location, isAdminRoute, isReviewRoute, isForm]);

  return (
    <>
      <RouterScrollRestoration />
      <Outlet />
    </>
  );
};

const addingInstanceRoute =  "/admin/add-package";
const clientAccess = "/admin-page";
const clientSite = "/admin-panel";
const clientEdit = "/admin/edit-package";

const router = createBrowserRouter([
  {
    element: <RootLayout />,
    errorElement: <NotFound />,
    children: [
      {
        path: '/',
        element: <Main />,
      },
      {
        path: '/Destinations/:placeName',
        element: <Card />,
      },
      {
        path: '/Search',
        element: <SearchPage />,
      },
      {
        path: '/Form',
        element: <Form />,
      },
       {
        path: '/reviews',
        element: <Reviews />,
      },
      {
        path: '/reviews/write',
        element: <WriteReviews />,
      },
      {
        path: '/packages/:slug',
        element: <Itinerary />,
      },
      {
        path: '/not-found',
        element: <NotFound />,
      },
      {
        path: clientAccess,
        element: <Admin />,
      },
      {
        path: clientSite,
        element: (
          <ProtectedRoute>
            <AdminPanel />
          </ProtectedRoute>
        ),
      },
      {
        path: addingInstanceRoute,
        element: (
          <ProtectedRoute>
            <AddPackage />
          </ProtectedRoute>
        ),
      },
      {
        path: `${clientEdit}/:id`,
        element: (
          <ProtectedRoute>
            <EditPackage />
          </ProtectedRoute>
        ),
      },
    ],
  },
]);

export default function App() {
  return (
    <div className="app-container">
      <RouterProvider router={router} />
    </div>
  );
}